import { jsx as _jsx } from "react/jsx-runtime";
import * as react from "react";
import { Color4LineComponent } from "shared-ui-components/lines/color4LineComponent.js";
import { Color4 } from "core/Maths/math.color.js";
export class Color4PropertyTabComponent extends react.Component {
    render() {
        const target = this.props.inputBlock.runtimeValue.value;
        const foo = {
            color: new Color4(target.r, target.g, target.b, target.a),
        };
        return (_jsx(Color4LineComponent, { lockObject: this.props.stateManager.lockObject, label: this.props.inputBlock.name, target: foo, propertyName: "color", onChange: () => {
                target.r = foo.color.r;
                target.g = foo.color.g;
                target.b = foo.color.b;
                target.a = foo.color.a;
                this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
            } }));
    }
}
//# sourceMappingURL=color4PropertyTabComponent.js.map